module.exports = __webpack_public_path__ + "img/silver-medal-2024.07ffebe2.png";